import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Provider Components
import { ProviderHeaderComponent } from './provider-header/provider-header.component';
import { ProviderLeftcontentComponent } from './provider-leftcontent/provider-leftcontent.component';
import { ProviderFooterComponent } from './provider-footer/provider-footer.component';
import { ProviderLoginComponent } from './provider-login/provider-login.component';
import { ProviderForgotPasswordComponent } from './provider-forgot-password/provider-forgot-password.component';
import { ProviderForgotUseridComponent } from './provider-forgot-userid/provider-forgot-userid.component';

// Import SharedModule for callback components
import { SharedModule } from '../shared/shared.module';
import { ProviderTermsConditionsComponent } from './provider-terms-conditions/provider-terms-conditions.component';
import { ProviderUpdatePasswordComponent } from './provider-update-password/provider-update-password.component';

@NgModule({
  declarations: [
    ProviderHeaderComponent,
    ProviderLeftcontentComponent,
    ProviderFooterComponent,
    ProviderLoginComponent,
    ProviderForgotPasswordComponent,
    ProviderForgotUseridComponent,
    ProviderTermsConditionsComponent,
    ProviderUpdatePasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    NgOtpInputModule,
    NgbModule,
    SharedModule
  ],
  exports: [
    ProviderHeaderComponent,
    ProviderLeftcontentComponent,
    ProviderFooterComponent,
    ProviderLoginComponent,
    ProviderForgotPasswordComponent,
    ProviderForgotUseridComponent,
    ProviderTermsConditionsComponent,
    ProviderUpdatePasswordComponent
  ]
})
export class ProviderModule { }
